import AddApproveNote from './AddApproveNote';

export default AddApproveNote;
